import React from 'react';
import { User, Users, Upload, Loader2 } from 'lucide-react';
import i18n from '../../i18n';
import swal from "sweetalert";
import { updateUserProfile } from '../../models/users';

export class ProfileUpdateSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profileInput: { ...props.user },
      vatFile: null,
      crCopyFile: null,
      idFile: null,
      is_loading: false,
      is_company: false
    };
  }

  handleProfileInputChange = (event) => {
    const { name, value } = event.target;
    this.setState(prevState => ({
      profileInput: {
        ...prevState.profileInput,
        [name]: value
      }
    }));
  };

  validateFileSize = (file) => {
    const MAX_FILE_SIZE = 5120; // 5MB
    const fileSizeKiloBytes = file.size / 1024;
    return fileSizeKiloBytes <= MAX_FILE_SIZE;
  };

  validateFileType = (file) => {
    const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
    return allowedTypes.includes(file.type);
  };

  handleProfileFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!this.validateFileSize(file)) {
      this.props.onError("File size should be less than 5MB");
      return;
    }

    if (!this.validateFileType(file)) {
      this.props.onError("File type not supported. Use JPEG, PNG, or PDF");
      return;
    }

    const fieldName = event.target.name;
    const fileStateMap = {
      "file_vat_certificate": "vatFile",
      "file_cr_number": "crCopyFile",
      "file_id_number": "idFile"
    };

    if (fileStateMap[fieldName]) {
      this.setState({ [fileStateMap[fieldName]]: file });
    }
  };

  handleUserTypeChange = (is_company) => {
    this.setState({ is_company });
  };

  handleProfileUpdate = async (formData) => {
    try {
      console.log("FormData values:", [...formData.entries()]);
      const response = await updateUserProfile(formData);

      if (response?.code === 200 || response?.success === true) {
        swal("Success", "Profile updated successfully.", "success");
        this.setState({ showUpdateProfile: false });
        await this.props.checkUserStatus();
        return true;
      } else {
        console.error("Profile update failed:", response);
        swal("Failed", response?.message || "Profile update failed.", "error");
        return false;
      }
    } catch (error) {
      console.error("Error during profile update:", error);
      swal("Failed", "Something went wrong. Please try again.", "error");
      return false;
    }
  };

  handleSave = async () => {
    const { profileInput, vatFile, crCopyFile, idFile, is_company } = this.state;
    const { onError, onSuccess } = this.props;

    // Validation
    if (is_company) {
      if (!profileInput.vat_number?.trim() || 
          !profileInput.cr_number?.trim() || 
          !profileInput.authority_name?.trim()) {
        onError("Please fill all required company fields");
        return;
      }
    } else {
      if (!profileInput.resident_card_number?.trim()) {
        onError("Please fill resident card number");
        return;
      }
      if (!profileInput.bank?.trim()) {
        onError("Please fill bank name");
        return;
      }
      if (!profileInput.account_number?.trim()) {
        onError("Please fill account number");
        return;
      }
    }

    this.setState({ is_loading: true });

    const formData = new FormData();
    formData.append("is_company", is_company);

    if (is_company) {
      formData.append("vat_number", profileInput.vat_number);
      formData.append("cr_number", profileInput.cr_number);
      formData.append("authority_name", profileInput.authority_name);

      if (vatFile) formData.append("file_vat_certificate", vatFile, vatFile.name);
      if (crCopyFile) formData.append("file_cr_number", crCopyFile, crCopyFile.name);
      if (idFile) formData.append("file_id_number", idFile, idFile.name);
    } else {
      formData.append("resident_card_number", profileInput.resident_card_number);
      formData.append("bank", profileInput.bank);
      formData.append("account_number", profileInput.account_number);
      if (idFile) formData.append("file_id_number", idFile, idFile.name);
    }

    try {
      const success = await this.handleProfileUpdate(formData);
      if (success) {
        onSuccess("Profile updated successfully");
      }
    } catch (error) {
      onError("Something went wrong");
    } finally {
      this.setState({ is_loading: false });
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.user !== this.props.user) {
      this.setState({ profileInput: { ...this.props.user } });
    }
  }

  render() {
    const { onClose, is_loading: externalLoading } = this.props;
    const { profileInput, vatFile, crCopyFile, idFile, is_loading, is_company } = this.state;
    const isLoading = is_loading || externalLoading;


    return (
       <div className="profile-update-section" style={{
        border: '2px solid #e1e8ed',
        borderRadius: '12px',
        padding: '1.5rem',
        marginBottom: '1.5rem',
        background: '#f8f9fa'
      }}>
        <div className="section-header" style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '1.5rem'
        }}>
          <div>

            <h3 style={{ margin: 0, color: '#2c3e50' }}>
              Update Your Profile
            </h3>
            <p style={{ margin: 0, color: '#4a5568', fontWeight: "normal", fontSize: "13px" }}>
              * This verification will be required only once.
            </p>

          </div>

          {/* <button
                        onClick={onClose}
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '1.5rem',
                            cursor: 'pointer',
                            color: '#666'
                        }}
                    >
                        ×
                    </button> */}
        </div>

        {/* User Type Switch */}
        <div className="user-type-switch" style={{
          display: 'flex',
          gap: '1rem',
          marginBottom: '1.5rem',
          width: '100%',
          justifyContent: 'center'
        }}>
          <div
            className={`payment-btn ${!is_company ? 'active' : ''}`}
            onClick={() => this.handleUserTypeChange(false)}
            style={{

              borderRadius: '20px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              width: '15rem',
              background: !is_company ? 'linear-gradient(135deg, #189397, #4fc1c0)' : 'white',
              color: !is_company ? 'white' : '#666',
              transition: 'all 0.3s ease'
            }}
          >
            <User size={20} />
            Individual
          </div>
          <div
            className={`payment-btn ${is_company ? 'active' : ''}`}
            onClick={() => this.handleUserTypeChange(true)}
            style={{


              borderRadius: '20px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              width: '15rem',
              background: is_company ? 'linear-gradient(135deg, #189397, #4fc1c0)' : 'white',
              color: is_company ? 'white' : '#666',
              transition: 'all 0.3s ease'
            }}
          >
            <Users size={20} />
            Company
          </div>
        </div>

        <div className='row'>

          <div className='col-md-6'>
            <div className="form-group">
              <label className="form-label">
                * {i18n.t("personal_card_no")}
              </label>
              <input
                className="form-control"
                type="text"
                name="resident_card_number"
                placeholder="Enter resident card number"
                value={profileInput.resident_card_number || ''}
                onChange={this.handleProfileInputChange}
              />
            </div>
          </div>

          <div className='col-md-6'>
            <div className="form-group">
              <label className="form-label">
                * {i18n.t('attach_id_no')}
              </label>
              <div className="file-input-container">
                <input
                  type="file"
                  className="file-input"
                  name="file_id_number"
                  onChange={this.handleProfileFileChange}
                />
                <div className={`file-input-display ${idFile ? 'has-file' : ''}`}>
                  <Upload size={20} />
                  <span>
                    {idFile ? idFile.name : 'Choose ID file'}
                  </span>
                </div>
              </div>
            </div>
          </div>


          <div className='col-md-6'>
            <div className="form-group">
              <label className="form-label">
                * {i18n.t("bank_name")}
              </label>
              <input
                className="form-control"
                type="text"
                name="bank"
                placeholder="Enter bank account Number"
                value={profileInput.bank || ''}
                onChange={this.handleProfileInputChange}
              />
            </div>
          </div>

           <div className='col-md-6'>
            <div className="form-group">
              <label className="form-label">
                * {i18n.t("account_number")}
              </label>
              <input
                className="form-control"
                type="text"
                name="account_number"
                placeholder="Enter bank account Number"
                value={profileInput.account_number || ''}
                onChange={this.handleProfileInputChange}
              />
            </div>
          </div>

          {/* Company Specific Fields */}
          {is_company && (
            <>
              <div className='col-md-6'>
                <div className="form-group">
                  <label className="form-label">
                    * {i18n.t("vat_number")}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="vat_number"
                    placeholder="Enter VAT number"
                    value={profileInput.vat_number || ''}
                    onChange={this.handleProfileInputChange}
                  />
                </div>
              </div>

              <div className='col-md-6'>
                <div className="form-group">
                  <label className="form-label">
                    * {i18n.t("cr_number")}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="cr_number"
                    placeholder="Enter CR number"
                    value={profileInput.cr_number || ''}
                    onChange={this.handleProfileInputChange}
                  />
                </div>
              </div>


              <div className='col-md-6'>
                <div className="form-group">
                  <label className="form-label">
                    {i18n.t("attacth_cr_copy")}
                  </label>
                  <div className="file-input-container">
                    <input
                      type="file"
                      className="file-input"
                      name="file_cr_number"
                      onChange={this.handleProfileFileChange}
                    />
                    <div className={`file-input-display ${crCopyFile ? 'has-file' : ''}`}>
                      <Upload size={20} />
                      <span>
                        {crCopyFile ? crCopyFile.name : 'Choose CR copy'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end', marginTop: '1.5rem' }}>

          <button
            onClick={() => this.handleSave()}
            disabled={isLoading}
            style={{
              padding: '0.75rem 1.5rem',
              border: 'none',
              borderRadius: '8px',
              background: 'linear-gradient(135deg, #189397, #4fc1c0)',
              color: 'white',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            {isLoading ? (
              <>
                <Loader2 size={20} className="loading-spinner" />
                Updating...
              </>
            ) : (
              'Update Profile'
            )}
          </button>
        </div>
      </div>
    );
  }
}